/** Placement-type bucket used throughout Explorer detail pages. */
export type PlacementBucket = 'content' | 'physical' | 'credits' | 'banner';

export const PLACEMENT_BUCKET_LABELS: Record<PlacementBucket | 'all', string> = {
    all: 'Todas',
    content: 'Contenido',
    physical: 'Físico',
    credits: 'Créditos',
    banner: 'Banner',
};

export const PLACEMENT_BUCKET_DESCRIPTIONS: Record<PlacementBucket, string> = {
    content: 'Menciones en contenido (lectura en episodio)',
    physical: 'Menciones de placement físico (on-screen / producto)',
    credits: 'Menciones en créditos (apertura o cierre)',
    banner: 'Menciones en banner (gráfico de patrocinio)',
};

export const PLACEMENT_BUCKET_SHORT: Record<PlacementBucket, string> = {
    content: 'cont.',
    physical: 'fís.',
    credits: 'créd.',
    banner: 'ban.',
};

/** Color associated with each placement bucket (matches WeeklyMovementsSection convention). */
export const PLACEMENT_BUCKET_COLORS: Record<PlacementBucket, string> = {
    content: '#1976d2',   // primary
    physical: '#2e7d32',  // success
    credits: '#ed6c02',   // warning
    banner: '#7b1fa2',    // purple — banner-only, not physical
};
